import React, { useEffect } from "react";
import { Form, Input, Button, Space, Select } from "antd";
import { toast } from "react-toastify";
import { useClinicStore } from "./store";
import { isEmpty } from "lodash";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { fourPlaceHolder } from "modules/utilities/utility";
import NoData from "assets/svgs/no_data/NoData";

const { Item } = Form;
const { Option } = Select;

const roleForFilter = [
  { name: "Clinic Executive", value: "clinic_executive" },
  { name: "Clinic Receptionist", value: "clinic_receptionist" },
  { name: "Clinic Doctor", value: "clinic_doctor" },
];

function EditClinic({ clinicId }) {
  const { clinicsAllData, getClnicDetails, editClinics, editClinicLoading } =
    useClinicStore();
  const [form] = Form.useForm();

  useEffect(() => {
    getClnicDetails(clinicId);
  }, [clinicId]);

  useEffect(() => {
    if (!isEmpty(clinicsAllData)) {
      const clinic = clinicsAllData;
      const clinicPersons = clinic.clinic_persons || [];
      const clinicPersonsFieldsValue = clinicPersons.map((person, index) => ({
        name: person.name || "N/A",
        email: person.email || "N/A",
        emp_code: person.emp_code || "N/A",
        type: person.type || "N/A",
        phone_number: person.phone_number || "N/A",
        key: index,
      }));

      form.setFieldsValue({
        clinicName: clinic.clinic_name,
        address: clinic.address,
        city: clinic.city,
        locality: clinic.locality,
        pincode: clinic.pincode,
        phoneNumber: clinic.phone_number,
        clinicPersons: clinicPersonsFieldsValue,
        location: clinic.location,
      });
    }
  }, [clinicsAllData, clinicId]);

  const onFinish = (values) => {
    const finalValues = { ...values, clinicId };
    const initialClinicPersons = clinicsAllData?.clinic_persons?.map(
      (person) => ({
        emp_code: person.emp_code,
        name: person.name,
        email: person.email,
        type: person.type,
        phone_number: person.phone_number,
      })
    );

    const payload = {
      clinicName: finalValues.clinicName,
      address: finalValues.address,
      locality: finalValues.locality,
      pincode: finalValues.pincode,
      removePersons: [],
      updatePersons: [],
      persons: [],
      clinic_id: clinicId,
      location: finalValues.location,
    };

    finalValues.clinicPersons.forEach((updatedPerson) => {
      const objectLength = Object.keys(updatedPerson).length;
      if (objectLength === 5) {
        payload.persons.push({
          name: updatedPerson.name,
          email: updatedPerson.email,
          type: updatedPerson.type,
          phone_number: updatedPerson.phone_number,
        });
      } else if (
        !initialClinicPersons.some(
          (person) => person.emp_code === updatedPerson.emp_code
        )
      ) {
        payload.removePersons.push({ emp_code: updatedPerson.emp_code });
      } else {
        payload.updatePersons.push({
          name: updatedPerson.name,
          email: updatedPerson.email,
          type: updatedPerson.type,
          emp_code: updatedPerson.emp_code,
          phone_number: updatedPerson.phone_number,
        });
      }
    });

    initialClinicPersons.forEach((initialPerson) => {
      if (
        !finalValues.clinicPersons.some(
          (person) => person.emp_code === initialPerson.emp_code
        )
      ) {
        payload.removePersons.push({ emp_code: initialPerson.emp_code });
      }
    });

    return;

    editClinics(payload, toast);

    if (!isError) {
      form.resetFields();
    }
  };

  const removeClinicPerson = (name, remove) => {
    remove(name);
  };

  return (
    <div>
      {editClinicLoading ? (
        fourPlaceHolder()
      ) : !isEmpty(clinicsAllData) ? (
        <>
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Item
                label="Clinic Name"
                name="clinicName"
                rules={[
                  { required: true, message: "Please input clinic name!" },
                ]}
                style={{ flex: 1, marginRight: "10px" }}
              >
                <Input />
              </Item>
              <Item
                label="Address"
                name="address"
                rules={[
                  { required: true, message: "Please input clinic address!" },
                ]}
                style={{ flex: 1, marginRight: "10px" }}
              >
                <Input />
              </Item>
              <Item
                label="City"
                name="city"
                rules={[
                  { required: true, message: "Please input clinic city!" },
                ]}
                style={{ flex: 1, marginRight: "10px" }}
              >
                <Input />
              </Item>
              <Item
                label="Locality"
                name="locality"
                rules={[
                  { required: true, message: "Please input clinic locality!" },
                ]}
                style={{ flex: 1, marginRight: "10px" }}
              >
                <Input />
              </Item>
              <Item
                label="Pincode"
                name="pincode"
                rules={[
                  { required: true, message: "Please input clinic pincode!" },
                ]}
                style={{ flex: 1, marginRight: "10px" }}
              >
                <Input />
              </Item>
              <Item
                label="Location"
                name="location"
                rules={[{ required: true, message: "Please input location!" }]}
                style={{ flex: 1, marginRight: "10px" }}
              >
                <Input />
              </Item>
            </div>
          </Form>
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Form.List name="clinicPersons">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space
                      key={key}
                      style={{ display: "flex", marginBottom: 8 }}
                      align="baseline"
                    >
                      <Item
                        {...restField}
                        label="Name"
                        name={[name, "name"]}
                        rules={[{ required: true, message: "Missing name" }]}
                      >
                        <Input placeholder="Name" />
                      </Item>
                      <Item {...restField} label="Email" name={[name, "email"]}>
                        <Input placeholder="Email" />
                      </Item>
                      <Item
                        {...restField}
                        label="phone_number"
                        name={[name, "phone_number"]}
                      >
                        <Input placeholder="Email" />
                      </Item>
                      <Item
                        {...restField}
                        label="Employee Code"
                        name={[name, "emp_code"]}
                      >
                        <Input placeholder="Employee Code" />
                      </Item>
                      <Item
                        {...restField}
                        label="Type"
                        name={[name, "type"]}
                        rules={[{ required: true, message: "Missing type" }]}
                      >
                        <Select placeholder="Select a role">
                          {roleForFilter.map((role) => (
                            <Option key={role.value} value={role.value}>
                              {role.name}
                            </Option>
                          ))}
                        </Select>
                      </Item>
                      <MinusCircleOutlined
                        onClick={() => removeClinicPerson(name, remove)}
                      />
                    </Space>
                  ))}
                  <Item style={{ width: "20%" }} className="float-start">
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Person
                    </Button>
                  </Item>
                </>
              )}
            </Form.List>
            <div className="px-3">
            <Item>
              <Button type="primary" htmlType="submit">
                Update
              </Button>
            </Item>
            </div>
          </Form>
        </>
      ) : (
        <div className="border p-2 rounded text-center">
          Error while Edit the data <NoData />
        </div>
      )}
    </div>
  );
}

export default EditClinic;
